//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../no/Builder.js";
import "../no/TextColorFontWidthBuilder.js";
import "../no/TextColorFontWidthBuilder.js";
let d=[[[0,"AnnotationSetSeparator",1,0],[0,"Offset",1,0],[0,"SourceTargetSeparator",1,0],[1,"TextCFW",0,"TextColorFontWidthBuilder",0],[0,"TextHeight",1,0],[0,"TextPositionHorizontal",1,0],[0,"TextPositionVertical",1,0]],[[[],"ResetToDefault",{},0,0]],[]];
SPLM.AME.GeneralAnnotationSettingsBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.GeneralAnnotationSettingsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AME.GeneralAnnotationSettingsBuilder.HorizontalTextPosition = Object.freeze({
    "Above" : "Above", "Below" : "Below"});

SPLM.AME.GeneralAnnotationSettingsBuilder.VerticalTextPosition = Object.freeze({
    "Left" : "Left", "Right" : "Right"});

SPLM.AME.GeneralAnnotationSettingsBuilder.SourceAndTargetSeparator = Object.freeze({
    "LessthanGreaterthan" : "LessthanGreaterthan", "SemiColon" : "SemiColon"});

SPLM.AME.GeneralAnnotationSettingsBuilder.AnnotationSeparator = Object.freeze({
    "SemiColon" : "SemiColon", "Comma" : "Comma", "Multiline" : "Multiline"});

export default SPLM;